import { createPartnerBasicInfo } from 'legacy/lut/services/partner360/basicInfo/createPartnerBasicInfo'
import { mapFormBasicInfoTo1091 } from 'legacy/lut/services/partner360/basicInfo/mappings/mapFormBasicInfoTo1091'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { CREATE_BASIC_INFO_DATA } from '../constants'
import { isBasicInfoCreated } from '../helpers/typeGuards'
import { IFormBasicInfo } from '../models/formBasicInfo'
import { TBasicInfoCreated } from '../models/partnerBasicInfo'
import { selectCreatedBasicInfo } from '../selectors/selectCreatedBasicinfo'

export const createBasicInfo = createAsyncThunk<TBasicInfoCreated | undefined, IFormBasicInfo>(
  CREATE_BASIC_INFO_DATA,
  async (formData, { getState }) => {
    const state = getState()

    const { entryId, fYear, partnerId, programType, ...storeData } = selectCreatedBasicInfo(state)

    const mappedData = mapFormBasicInfoTo1091({ ...storeData, ...formData })
    const createdData = await createPartnerBasicInfo({
      ...mappedData,
      PartnerId: partnerId,
      FYear: fYear,
      ProgramType: programType,
    })

    return isBasicInfoCreated(createdData) ? createdData : undefined
  }
)
